<article
  class="cert-card"
  [attr.aria-label]="certification.name + ' - ' + statusLabel"
>
  <div class="cert-card__image cert-card__image--{{ certification.status }}">
    <!-- Ellipse decoration -->
    <svg
      class="cert-card__ellipse"
      xmlns="http://www.w3.org/2000/svg"
      width="130"
      height="120"
      viewBox="0 0 130 120"
      fill="none"
      aria-hidden="true"
    >
      <ellipse opacity="0.3" cx="66" cy="60" rx="66" ry="66" transform="rotate(-180 66 60)" [attr.fill]="isLocked ? '#717680' : (certification.status === 'completed' ? '#079455' : '#007D97')"/>
    </svg>

    <!-- Trophy icon -->
    <svg
      class="cert-card__trophy"
      xmlns="http://www.w3.org/2000/svg"
      width="94"
      height="94"
      viewBox="0 0 94 94"
      fill="none"
      aria-hidden="true"
    >
      <g opacity="0.3">
        <path d="M47.0002 58.7499C34.0215 58.7499 23.5002 48.2286 23.5002 35.2499V13.4907C23.5002 11.8698 23.5002 11.0593 23.7364 10.4103C24.1323 9.32242 24.9893 8.46543 26.0773 8.06946C26.7262 7.83325 27.5367 7.83325 29.1576 7.83325H64.8428C66.4637 7.83325 67.2741 7.83325 67.9231 8.06946C69.011 8.46543 69.868 9.32242 70.264 10.4103C70.5002 11.0593 70.5002 11.8698 70.5002 13.4907V35.2499C70.5002 48.2286 59.9789 58.7499 47.0002 58.7499ZM47.0002 58.7499V70.4999M70.5002 15.6666H80.2918C82.1168 15.6666 83.0292 15.6666 83.749 15.9647C84.7087 16.3622 85.4712 17.1247 85.8687 18.0844C86.1668 18.8042 86.1668 19.7166 86.1668 21.5416V23.4999C86.1668 27.1423 86.1668 28.9635 85.7665 30.4577C84.68 34.5125 81.5128 37.6797 77.458 38.7662C75.9637 39.1666 74.1426 39.1666 70.5002 39.1666M23.5002 15.6666H13.7085C11.8836 15.6666 10.9711 15.6666 10.2513 15.9647C9.29163 16.3622 8.52915 17.1247 8.13163 18.0844C7.8335 18.8042 7.8335 19.7166 7.8335 21.5416V23.4999C7.8335 27.1423 7.8335 28.9635 8.23387 30.4577C9.32036 34.5125 12.4875 37.6797 16.5424 38.7662C18.0366 39.1666 19.8578 39.1666 23.5002 39.1666M29.1576 86.1666H64.8428C65.8041 86.1666 66.5835 85.3872 66.5835 84.4258C66.5835 76.7348 60.3486 70.4999 52.6576 70.4999H41.3428C33.6517 70.4999 27.4168 76.7348 27.4168 84.4258C27.4168 85.3872 28.1962 86.1666 29.1576 86.1666Z"
          [attr.stroke]="isLocked ? '#A4A7AE' : (certification.status === 'completed' ? '#17B26A' : '#00A8CC')"
          stroke-width="7"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </g>
    </svg>
  </div>

  <div class="cert-card__body">
    <div class="cert-card__badge-row">
      <span class="cert-card__badge cert-card__badge--{{ certification.status }}">
        @if (certification.status === 'locked') {
          <svg class="cert-card__badge-icon" xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none" aria-hidden="true">
            <path d="M8.5 5V4C8.5 2.61929 7.38071 1.5 6 1.5C4.61929 1.5 3.5 2.61929 3.5 4V5M6 7.25V8.25M4.4 10.5H7.6C8.44008 10.5 8.86012 10.5 9.18099 10.3365C9.46323 10.1927 9.6927 9.96323 9.83651 9.68099C10 9.36012 10 8.94008 10 8.1V7.4C10 6.55992 10 6.13988 9.83651 5.81901C9.6927 5.53677 9.46323 5.3073 9.18099 5.16349C8.86012 5 8.44008 5 7.6 5H4.4C3.55992 5 3.13988 5 2.81901 5.16349C2.53677 5.3073 2.3073 5.53677 2.16349 5.81901C2 6.13988 2 6.55992 2 7.4V8.1C2 8.94008 2 9.36012 2.16349 9.68099C2.3073 9.96323 2.53677 10.1927 2.81901 10.3365C3.13988 10.5 3.55992 10.5 4.4 10.5Z" stroke="#717680" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        } @else if (certification.status === 'completed') {
          <svg class="cert-card__badge-icon" xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none" aria-hidden="true">
            <g [attr.clip-path]="'url(#clip_completed_' + clipId + ')'">
              <path d="M3.75 6L5.25 7.5L8.25 4.5M11 6C11 8.76142 8.76142 11 6 11C3.23858 11 1 8.76142 1 6C1 3.23858 3.23858 1 6 1C8.76142 1 11 3.23858 11 6Z" stroke="#079455" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            </g>
            <defs><clipPath [id]="'clip_completed_' + clipId"><rect width="12" height="12" fill="white"/></clipPath></defs>
          </svg>
        } @else if (certification.status === 'in-progress') {
          <svg class="cert-card__badge-icon" xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none" aria-hidden="true">
            <g [attr.clip-path]="'url(#clip_progress_' + clipId + ')'">
              <path d="M6 1V3M6 9V11M3 6H1M11 6H9M9.53921 9.53921L8.125 8.125M9.53921 2.49997L8.125 3.91418M2.46079 9.53921L3.875 8.125M2.46079 2.49997L3.875 3.91418" stroke="#007D97" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            </g>
            <defs><clipPath [id]="'clip_progress_' + clipId"><rect width="12" height="12" fill="white"/></clipPath></defs>
          </svg>
        } @else {
          <svg class="cert-card__badge-icon" xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none" aria-hidden="true">
            <g [attr.clip-path]="'url(#clip_circle_' + clipId + ')'">
              <path d="M6 11C8.76142 11 11 8.76142 11 6C11 3.23858 8.76142 1 6 1C3.23858 1 1 3.23858 1 6C1 8.76142 3.23858 11 6 11Z" stroke="#007D97" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            </g>
            <defs><clipPath [id]="'clip_circle_' + clipId"><rect width="12" height="12" fill="white"/></clipPath></defs>
          </svg>
        }
        {{ statusLabel }}
      </span>

      @if (showCompletionDate) {
        <span class="cert-card__badge-date">{{ certification.completion_date | date:'MM/dd/yy':'UTC' }}</span>
      }
      @if (showAllowedRuns) {
        <span class="cert-card__badge-date">{{ certification.max_allowed_runs }} runs</span>
      }
    </div>

    <h3 class="cert-card__name">
      {{ certification.name }}
      @if (inviteOnlyLabel) {
        <span class="cert-card__invite-only">{{ inviteOnlyLabel }}</span>
      }
    </h3>

    <p class="cert-card__description">{{ certification.description }}</p>

    @if (showRunInfo) {
      <p class="cert-card__run-info">
        {{ certification.completed_runs }}/{{ certification.max_allowed_runs }} runs &middot;
        @if (certification.completion_date) {
          Since {{ certification.completion_date | date:'MM/dd/yy':'UTC' }}
        }
      </p>
    }

    @if (showDetailsButton) {
      <button
        type="button"
        class="cert-card__btn"
        [attr.aria-label]="'See details for ' + certification.name"
        (click)="onSeeDetails()"
      >
        See Details
      </button>
    }
  </div>
</article>
